import {Reference, ReferenceQuery, ValueFilter} from '@/model/types';

export const ValueFilterHelpers = {
  isNotIn<T extends string[] | Reference | ReferenceQuery>(value: T) {
    return {operator: 'not in', value} as const satisfies ValueFilter;
  },

  isIn<T extends string[] | Reference | ReferenceQuery>(value: T) {
    return {operator: 'in', value} as const satisfies ValueFilter;
  },
};
